import { z } from 'zod';

export const TestStatus = z.enum(['pending', 'running', 'passed', 'failed', 'skipped']);

export type TestStatus = z.infer<typeof TestStatus>;

export const GameVersionSchema = z.object({
  id: z.string().uuid(),
  game_id: z.string().uuid(),
  version: z.string().regex(/^\d+\.\d+\.\d+$/),
  source: z.string().min(1),
  config: z.record(z.unknown()).default({}),
  changelog: z.string().max(5000).default(''),
  test_status: TestStatus.default('pending'),
  created_at: z.string().datetime(),
});

export type GameVersion = z.infer<typeof GameVersionSchema>;

export const GameVersionCreateInput = GameVersionSchema.omit({
  id: true,
  created_at: true,
}).extend({
  test_status: TestStatus.default('pending'),
  config: z.record(z.unknown()).default({}),
  changelog: z.string().max(5000).default(''),
});

export type GameVersionCreateInput = z.infer<typeof GameVersionCreateInput>;
